
import Vue from 'vue';
import Component from 'vue-class-component';
import {
 Getter, Action, Mutation, namespace,
} from 'vuex-class';
import eventHubManager from 'modules/mixin/views/EventHub';
import CompanyLayoutStudio from './CompanyLayoutStudio.vue';

// tslint:disable-next-line:variable-name
const CompanyAction = namespace('company').Action;
// tslint:disable-next-line:variable-name
const CompanyGetter = namespace('company').Getter;

@Component({
  name: 'CompanyFastLayoutStudio',
  props: {
    defaults: {
      type: Object,
      required: false,
    },
  },
})
export default class CompanyFastLayoutStudio extends CompanyLayoutStudio {
  @CompanyAction('schema') loadSchema: (suffix: string) => Promise<any>;

  @CompanyAction('loadNew') loadNew: (id: number) => Promise<any>;

  @CompanyAction('reset') reset: () => Promise<any>;

  defaults: any;

  async mounted() {
    await this.reset();
    await this.loadSchema(null);
    await this.loadNew(this.defaults);
  }

  get eventHub(): Vue {
    return eventHubManager.getHub('company.fast');
  }
}
